import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadMediaPipe } from './load-media.pipe';
import { NoComma } from './no-comma.pipe';
import { NumberPipe } from './number.pipe';
import { CcyPipe } from './ccy.pipe';
import { SmartPricePipe } from './smart-price.pipe';
import { SortProjectsPipe } from './sort-projects.pipe';
import { ScreenLessThanPipe } from './screen-less-than.pipe';
import { YearsPipe } from './years.pipe';
import { OrderByPipe } from './order-by.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SortValues } from './sort-values.pipe';
import { PluralPipe } from './plural.pipe';
import { LimitElementsPipe } from './limit-elements.pipe';
import { SanitizeStylePipe } from './sanitize-style.pipe';
import { FilterByPipe } from './filter-by.pipe';

@NgModule({
  declarations: [
    LoadMediaPipe,
    NoComma,
    NumberPipe,
    CcyPipe,
    SmartPricePipe,
    SortProjectsPipe,
    ScreenLessThanPipe,
    YearsPipe,
    OrderByPipe,
    SafeHtmlPipe,
    SortValues,
    PluralPipe,
    LimitElementsPipe,
    SanitizeStylePipe,
    FilterByPipe,
  ],
  imports: [CommonModule],
  exports: [
    LoadMediaPipe,
    NoComma,
    NumberPipe,
    CcyPipe,
    SmartPricePipe,
    SortProjectsPipe,
    ScreenLessThanPipe,
    YearsPipe,
    OrderByPipe,
    SafeHtmlPipe,
    SortValues,
    PluralPipe,
    LimitElementsPipe,
    SanitizeStylePipe,
    FilterByPipe,
  ],
})
export class PipesModule {}
